// src/components/Layout.js
import React from 'react';
import Nav from './Nav';
import InlineStyles from '../InlineStyles';
import JsonLdComponent from '../JsonLdComponent';
import { Link } from 'react-router-dom';

function Layout({ language = 'en', children }) {
  const prefix = language === 'en' ? '' : `/${language}`;

  return (
    <div className="app-container" data-lang={language} style={{ padding: 0, display: 'block' }}>
      <InlineStyles />
      <JsonLdComponent />
      <Nav language={language} />
      <div style={{ padding: '32px 16px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {children}
        <div className="footer" style={{ width: '100%', maxWidth: 960, textAlign: 'center', marginTop: 0 }}>
          <div className="footer-links" style={{ display: 'flex', justifyContent: 'center', gap: 24, flexWrap: 'wrap' }}>
            <Link to={`${prefix}/terms`} className="footer-link">Terms &amp; Conditions</Link>
            <Link to={`${prefix}/privacy-policy`} className="footer-link">Privacy Policy</Link>
            <Link to={`${prefix}/contact`} className="footer-link">Contact</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
